import {useEffect} from 'react';
import {Drawer} from 'components/customer/Product/entity/Drawer';
import {DrawerParameters} from 'components/customer/Product/entity/DrawerParameters';
import {FreeSpace} from 'components/customer/Product/Drawer/helpers/innerDrawerSlots';
import {useInnerDrawerSpaces} from 'components/customer/Product/Drawer/helpers/useInnerDrawerSpaces';

export interface Spaces {
    spaces: FreeSpace[];
    place: (space: FreeSpace) => Drawer[];
    known: boolean;
}

interface InnerDrawerSpacesProps {
    drawerParams: DrawerParameters;
    onChange: (spaces: Spaces) => void;
}

// Works out the free spaces only while it is mounted, in Edit layout: its
// runner lookup re-renders with every change to the drawers, which the whole
// layout need not do while it loads.
export const InnerDrawerSpaces = ({
    drawerParams,
    onChange,
}: InnerDrawerSpacesProps): JSX.Element => {
    const {spaces, place, known} = useInnerDrawerSpaces(drawerParams);

    useEffect(
        () => onChange({spaces, place, known}),
        [spaces, place, known, onChange]
    );

    useEffect(() => () => onChange(null), [onChange]);

    return null;
};
